<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    size="lg"
    :ok-title="modal_botao"
    no-close-on-backdrop
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row>
        <b-col>
          <label>Placa</label>
          <b-form-input
            type="text"
            placeholder="Placa"
            v-model="form.placa"
            name="placa"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('placa')"
            v-if="form.errors.has('placa')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Renavam</label>
          <b-form-input
            type="text"
            placeholder="Renavam"
            v-model="form.renavam"
            name="renavam"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('renavam')"
            v-if="form.errors.has('renavam')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Número ANTT</label>
          <b-form-input
            type="text"
            placeholder="Número ANTT"
            v-model="form.num_antt"
            name="num_antt"
            maxlength="9"
            @input="onNumAnttInput"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('num_antt')"
            v-if="form.errors.has('num_antt')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Capacidade KG(Minimo)</label>
          <currency-input
            class="form-control"
            v-model="form.capacidade_kg_min"
            :auto-decimal-mode="true"
            placeholder="Valor"
            :currency="{ prefix: '' }"
            :distraction-free="getCurrency"
          />
          <b-form-feedback
            v-text="form.errors.get('capacidade_kg_min')"
            v-if="form.errors.has('capacidade_kg_min')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Capacidade KG(Maximo)</label>
          <currency-input
            class="form-control"
            v-model="form.capacidade_kg"
            :auto-decimal-mode="true"
            placeholder="Valor"
            :currency="{ prefix: '' }"
            :distraction-free="getCurrency"
          />
          <b-form-feedback
            v-text="form.errors.get('capacidade_kg')"
            v-if="form.errors.has('capacidade_kg')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Capacidade M<sup>3</sup>(Minimo)</label>
          <currency-input
            class="form-control"
            v-model="form.capacidade_m3_min"
            :auto-decimal-mode="true"
            placeholder="Valor"
            :currency="{ prefix: '' }"
            :distraction-free="getCurrency"
            :maxlength=15
          />
          <b-form-feedback
            v-text="form.errors.get('capacidade_m3_min')"
            v-if="form.errors.has('capacidade_m3_min')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Capacidade M<sup>3</sup>(Maximo)</label>
          <currency-input
            class="form-control"
            v-model="form.capacidade_m3"
            :auto-decimal-mode="true"
            placeholder="Valor"
            :currency="{ prefix: '' }"
            :distraction-free="getCurrency"
            :maxlength=15
          />
          <b-form-feedback
            v-text="form.errors.get('capacidade_m3')"
            v-if="form.errors.has('capacidade_m3')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Tara</label>
          <currency-input
            class="form-control"
            v-model="form.tara"
            :auto-decimal-mode="true"
            placeholder="Valor"
            :currency="{ prefix: '' }"
            :distraction-free="getCurrency"
          />
          <b-form-feedback
            v-text="form.errors.get('tara')"
            v-if="form.errors.has('tara')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Tipo Veículo</label>
          <multiselect
            v-model="paramVeiculoSelected"
            :options="optionsParamTipoVeiculo"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('partipvei_id')"
            v-if="form.errors.has('partipvei_id')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Tipo Carroceria</label>
          <multiselect
            v-model="tpCarroceriaSelected"
            :options="optionsParamTipoCarroceria"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('partipcro_id')"
            v-if="form.errors.has('partipcro_id')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Tipo Rodado</label>
          <multiselect
            v-model="tpRodadoSelected"
            :options="optionsParamTipoRodado"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('partiprod_id')"
            v-if="form.errors.has('partiprod_id')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Tipo Proprietário</label>
          <multiselect
            v-model="tpProprietarioSelected"
            :options="optionsParamTipoProprietario"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('partipppt_id')"
            v-if="form.errors.has('partipppt_id')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Municipio</label>
          <multiselect
            v-model="municipioSelected"
            :options="optionsMunicipio"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('municipio_id')"
            v-if="form.errors.has('municipio_id')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Status</label>
          <multiselect
            v-model="statusSelected"
            :options="optionsLivStatus"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('status')"
            v-if="form.errors.has('status')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Proprietário</label>
          <multiselect
            v-model="pessoaSelected"
            :options-limit="300"
            :limit="2"
            :limit-text="limitText"
            :options="optionsProprietario"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Digite ao menos 3 caracteres"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            :searchable="true"
            :loading="isLoadingProprietario"
            @search-change="listaProprietario"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('pessoa_id')"
            v-if="form.errors.has('pessoa_id')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Motoristas</label>
          <multiselect
            v-model="motoristas"
            :options="optionsMotorista"
            track-by="value"
            label="label"
            :limit="10"
            :multiple="true"
            :clear-on-select="false"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            v-text="form.errors.get('motoristas')"
            v-if="form.errors.has('motoristas')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="2" sm="2">
          <label>Transportadora?</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.agenciado"
              :options="optionsAgenciado"
              name="agenciado"
              plain
              stacked
              value-field="value"
              :disabled="true"
            ></b-form-radio-group>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('agenciado')"
              v-if="form.errors.has('agenciado')"
            ></b-form-feedback>
          </b-form-group>
        </b-col>
        <b-col md="2" sm="2">
          <label>Tipo de Vinculo</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.tp_vinculo"
              :options="optionsTpVinculo"
              name="tp_vinculo"
              plain
              stacked
              value-field="value"
            ></b-form-radio-group>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_vinculo')"
              v-if="form.errors.has('tp_vinculo')"
            ></b-form-feedback>
          </b-form-group>
        </b-col>
        <b-col md="3" sm="3" class="p-0">
          <label>Transportadora</label>
          <multiselect
            v-model="agenciadorSelected"
            :options-limit="300"
            :limit="2"
            :limit-text="limitText"
            :options="optionsCliente"
            :disabled="this.form.agenciado != 1"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Digite ao menos 3 caracteres"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            :searchable="true"
            :loading="isLoadingExp"
            @search-change="listaClientesCliente"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('pessoa_id_agenciador')"
            v-if="form.errors.has('pessoa_id_agenciador')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <br />
          <h3 class="panel-title with-border">Detalhes opcionais</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Tipo do veículo</label>
          <multiselect
            v-model="tpVeiculoSelected"
            :options="optionsTipoVeiculo"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('tp_veiculo')"
            v-if="form.errors.has('tp_veiculo')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Marca</label>
          <multiselect
            v-model="marcaSelected"
            :options="optionsMarca"
            track-by="value"
            @input="ajustaModelo(marcaSelected)"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('veiculo_detalhe.marvei_id')"
            v-if="form.errors.has('veiculo_detalhe.marvei_id')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Modelo</label>
          <multiselect
            v-model="modeloSelected"
            :options="optionsModelo"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('veiculo_detalhe.modvei_id')"
            v-if="form.errors.has('veiculo_detalhe.modvei_id')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Cor</label>
          <multiselect
            v-model="corSelected"
            :options="optionsCor"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('veiculo_detalhe.corvei_id')"
            v-if="form.errors.has('veiculo_detalhe.corvei_id')"
          ></b-form-feedback>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <label>Tipo do combustivel</label>
          <multiselect
            v-model="tpCombustivelSelected"
            :options="optionsTpCombustivel"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('veiculo_detalhe.partpcomb_id')"
            v-if="form.errors.has('veiculo_detalhe.partpcomb_id')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Tipo Cambio</label>
          <multiselect
            v-model="tpCambioSelected"
            :options="optionsTpCambio"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('veiculo_detalhe.tp_cambio')"
            v-if="form.errors.has('veiculo_detalhe.tp_cambio')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Blindado</label>
          <multiselect
            v-model="isBlindadoSelected"
            :options="optionsIsBlindado"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('veiculo_detalhe.is_blindado')"
            v-if="form.errors.has('veiculo_detalhe.is_blindado')"
          ></b-form-feedback>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <label>Chassi</label>
          <b-form-input
            type="text"
            placeholder="Chassi"
            v-model="veiculo_detalhe.chassi"
            name="chassi"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('veiculo_detalhe.chassi')"
            v-if="form.errors.has('veiculo_detalhe.chassi')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Ano Fabricação</label>
          <b-form-input
            type="text"
            placeholder="Ano Fabricação"
            v-model="veiculo_detalhe.ano_fabricacao"
            name="ano_fabricacao"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('veiculo_detalhe.ano_fabricacao')"
            v-if="form.errors.has('veiculo_detalhe.ano_fabricacao')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Ano Modelo</label>
          <b-form-input
            type="text"
            placeholder="Ano Modelo"
            v-model="veiculo_detalhe.ano_modelo"
            name="ano_modelo"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('veiculo_detalhe.ano_modelo')"
            v-if="form.errors.has('veiculo_detalhe.ano_modelo')"
          ></b-form-feedback>
        </b-col>
        <b-col>
          <label>Cilindradas</label>
          <b-form-input
            type="text"
            placeholder="Cilindradas"
            v-model="veiculo_detalhe.cilindradas"
            name="cilindradas"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('veiculo_detalhe.cilindradas')"
            v-if="form.errors.has('veiculo_detalhe.cilindradas')"
          ></b-form-feedback>
        </b-col>

        <b-col>
          <label>Potência</label>
          <b-form-input
            type="text"
            placeholder="Potência"
            v-model="veiculo_detalhe.potencia"
            name="potencia"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('veiculo_detalhe.potencia')"
            v-if="form.errors.has('veiculo_detalhe.potencia')"
          ></b-form-feedback>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <label>Observação</label>
          <b-form-textarea
            name="obs"
            v-model="veiculo_detalhe.obs"
            placeholder="Observação"
            :rows="3"
            :max-rows="6"
          >
          </b-form-textarea>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('veiculo_detalhe.obs')"
            v-if="form.errors.has('veiculo_detalhe.obs')"
          ></b-form-feedback>
        </b-col>
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import AvisoErros from "../components/AvisoErros";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      isLoadingProprietario: false,
      isLoadingExp: false,
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      optionsLivStatus: [],
      optionsMunicipio: [],
      optionsModelo: [],
      optionsParamTipoRodado: [],
      optionsParamTipoVeiculo: [],
      optionsParamTipoCarroceria: [],
      optionsParamTipoPropriedade: [],
      optionsParamTipoProprietario: [],
      optionsAgenciado: [],
      optionsMotorista: [],
      optionsCor: [],
      optionsIsBlindado: [],
      optionsMarca: [],
      modeloSelected: [],
      optionsTpCambio: [],
      optionsTpCombustivel: [],
      optionsTpVinculo: [],
      optionsTipoVeiculo: [],
      optionsCliente: [],
      optionsProprietario: [],
      statusSelected: [],
      municipioSelected: [],
      tpProprietarioSelected: [],
      tpRodadoSelected: [],
      tpCarroceriaSelected: [],
      tpVeiculoSelected: [],
      pessoaSelected: [],
      corSelected: [],
      isBlindadoSelected: [],
      marcaSelected: [],
      tpCambioSelected: [],
      agenciadorSelected: [],
      optionsAgenciador: [],
      tpVeiculoDetSelected: [],
      tpCombustivelSelected: [],
      paramVeiculoSelected: [],
      motoristas: [],
      errors_array: [],
      veiculo_detalhe: {},
      form: new Form({
        placa: "",
        renavam: "",
        num_antt: "",
        capacidade_kg: 0,
        capacidade_kg_min: 0,
        capacidade_m3: 0,
        capacidade_m3_min: 0,
        motoristas: [],
        tara: 0,
        pessoa_id: "",
        partipvei_id: "",
        partipcro_id: "",
        partiprod_id: "",
        partipppt_id: "",
        status: "",
        municipio_id: "",
        veiculo_detalhe: {},
        obs: "",
        veiculo_id: "",
        agenciado: 1, // Valor padrão ajustado para "sim"
        tp_vinculo: "",
        pessoa_id_agenciador: [],
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    isBlindadoSelected(obj) {
      this.veiculo_detalhe.is_blindado = obj.value;
    },
    marcaSelected(obj) {
      this.veiculo_detalhe.marvei_id = obj.value;
    },
    modeloSelected(obj) {
      this.veiculo_detalhe.modvei_id = obj.value;
    },
    corSelected(obj) {
      this.veiculo_detalhe.corvei_id = obj.value;
    },
    tpCambioSelected(obj) {
      this.veiculo_detalhe.tp_cambio = obj.value;
    },
    tpVeiculoDetSelected(obj) {
      this.form.tp_veiculo = obj.value;
    },
    tpVeiculoSelected(obj) {
      this.veiculo_detalhe.tp_veiculo = obj.value;
    },
    tpCombustivelSelected(obj) {
      this.veiculo_detalhe.partpcomb_id = obj.value;
    },
    statusSelected(obj) {
      this.form.status = obj.value;
    },
    municipioSelected(obj) {
      this.form.municipio_id = obj.value;
    },
    tpProprietarioSelected(obj) {
      this.form.partipppt_id = obj.value;
    },
    tpRodadoSelected(obj) {
      if (!obj || Array.isArray(obj) || obj.value == null) {
        return;
      }
      this.form.partiprod_id = obj.value;
      const kg = obj.capacidade_peso ? obj.capacidade_peso : obj.capacidade_kg;
      const kgMin = obj.capacidade_peso_min ? obj.capacidade_peso_min : obj.capacidade_kg_min;
      const m3 = obj.volume ? obj.volume : obj.capacidade_m3;
      const m3Min = obj.volume_min ? obj.volume_min : obj.capacidade_m3_min;
      const isFiniteNumber = (v) => {
        const x = Number(v);
        return Number.isFinite(x) ? x : 0;
      };  
      this.form.capacidade_kg = isFiniteNumber(kg);
      this.form.capacidade_kg_min = isFiniteNumber(kgMin);
      this.form.capacidade_m3 = isFiniteNumber(m3);
      this.form.capacidade_m3_min = isFiniteNumber(m3Min);
    },
    tpCarroceriaSelected(obj) {
      this.form.partipcro_id = obj.value;
    },
    paramVeiculoSelected(obj) {
      this.form.partipvei_id = obj.value;
    },
    pessoaSelected(obj) {
      this.form.pessoa_id = obj.value;
    },
    agenciadorSelected(obj) {
      this.form.pessoa_id_agenciador = obj.value;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    onNumAnttInput(value) {
      this.form.num_antt = String(value || "")
        .replace(/\D/g, "")
        .slice(0, 9);
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.veiculo_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.veiculo_detalhe = {};
      this.corSelected = [];
      this.motoristas = [];
      this.isBlindadoSelected = [];
      this.marcaSelected = [];
      this.tpCambioSelected = [];
      this.tpVeiculoDetSelected = [];
      this.tpVeiculoSelected = [];
      this.tpCombustivelSelected = [];
      this.statusSelected = [];
      this.municipioSelected = [];
      this.tpProprietarioSelected = [];
      this.form.capacidade_kg = parseInt(0, 10);
      this.form.capacidade_kg_min = parseInt(0, 10);
      this.form.capacidade_m3 = parseInt(0, 10);
      this.form.capacidade_m3_min = parseInt(0, 10);
      this.form.tara = parseInt(0, 10);
      this.form.agenciado = 1;
      this.tpRodadoSelected = [];
      this.tpCarroceriaSelected = [];
      this.paramVeiculoSelected = [];
      this.agenciadorSelected = [];
      this.pessoaSelected = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.veiculo_detalhe = {};
      this.corSelected = [];
      this.motoristas = [];
      this.agenciadorSelected = [];
      this.isBlindadoSelected = [];
      this.marcaSelected = [];
      this.tpCambioSelected = [];
      this.tpVeiculoDetSelected = [];
      this.tpVeiculoSelected = [];
      this.tpCombustivelSelected = [];
      this.statusSelected = [];
      this.municipioSelected = [];
      this.tpProprietarioSelected = [];
      this.tpRodadoSelected = [];
      this.tpCarroceriaSelected = [];
      this.paramVeiculoSelected = [];
      this.pessoaSelected = [];
      this.form.placa = data.placa;
      this.form.renavam = String(data.renavam);
      this.form.num_antt =
        data.num_antt != null && data.num_antt !== ""
          ? String(data.num_antt)
          : "";
      this.form.capacidade_kg = data.capacidade_kg;
      this.form.capacidade_kg_min = data.capacidade_kg_min;
      this.form.capacidade_m3 = data.capacidade_m3;
      this.form.capacidade_m3_min = data.capacidade_m3_min;
      this.form.tara = data.tara;
      this.form.agenciado = 1;
      if(data.tp_vinculo != null){
        this.form.tp_vinculo = data.tp_vinculo.valor;
      }
      this.paramVeiculoSelected = {
        label: data.param_tipo_veiculo.descr,
        value: data.param_tipo_veiculo.partipvei_id,
      };
      this.tpCarroceriaSelected = {
        label: data.param_tipo_carroceria.descr,
        value: data.param_tipo_carroceria.partipcro_id,
      };
      if(data.veiculo_detalhe.param_tipo_combustivel != null){
        this.tpCombustivelSelected = {
          label: data.veiculo_detalhe.param_tipo_combustivel.descr,
          value: data.veiculo_detalhe.param_tipo_combustivel.partpcomb_id
        }
      }
      this.tpRodadoSelected = {
        label: data.param_tipo_rodado.descr,
        value: data.param_tipo_rodado.partiprod_id,
        capacidade_kg: data.capacidade_kg,
        capacidade_kg_min: data.capacidade_kg_min,
        capacidade_m3: data.capacidade_m3,
        capacidade_m3_min: data.capacidade_m3_min,
      };
      if(data.param_tipo_proprietario != null){
        this.tpProprietarioSelected = {
          label: data.param_tipo_proprietario.descr,
          value: data.param_tipo_proprietario.partipppt_id,
        };
      }
      this.municipioSelected = {
        label: data.municipio.nome,
        value: data.municipio.municipio_id,
      };
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor,
      };
      if (data.pessoa_id !== null) {
        if (data.pessoa.pessoa_fisica != null) {
          this.pessoaSelected = {
            label: data.pessoa.pessoa_fisica.nome,
            value: data.pessoa.pessoa_id,
          };
        }
        if (data.pessoa.pessoa_juridica != null) {
          this.pessoaSelected = {
            label: data.pessoa.pessoa_juridica.razao_social,
            value: data.pessoa.pessoa_id,
          };
        }
      }
      if (data.pessoa_agenciador !== null) {
        if (data.pessoa_agenciador.pessoa_fisica !== null) {
          this.agenciadorSelected = {
            label: data.pessoa_agenciador.pessoa_fisica.nome,
            value: data.pessoa_agenciador.pessoa_id,
          };
        }
        if (data.pessoa_agenciador.pessoa_juridica !== null) {
          this.agenciadorSelected = {
            label:
              data.pessoa_agenciador.pessoa_juridica.razao_social +
              "-" +
              this.onFormataCnpj(
                data.pessoa_agenciador.pessoa_juridica.cnpj_base,
                data.pessoa_agenciador.pessoa_juridica.cnpj_filial,
                data.pessoa_agenciador.pessoa_juridica.cnpj_digito
              ),
            value: data.pessoa_agenciador.pessoa_id,
          };
        }
        if (data.pessoa_agenciador.pessoa_exterior !== null) {
          this.agenciadorSelected = {
            label: data.pessoa_agenciador.pessoa_exterior.nome,
            value: data.pessoa_agenciador.pessoa_id,
          };
        }
      }
      if (data.veiculo_detalhe) {
        this.veiculo_detalhe.cilindradas = data.veiculo_detalhe.cilindradas;
        this.veiculo_detalhe.potencia = data.veiculo_detalhe.potencia;
        this.veiculo_detalhe.chassi = data.veiculo_detalhe.chassi;
        this.veiculo_detalhe.ano_fabricacao =
          data.veiculo_detalhe.ano_fabricacao;
        this.veiculo_detalhe.ano_modelo = data.veiculo_detalhe.ano_modelo;
        this.veiculo_detalhe.obs = data.veiculo_detalhe.obs;
        if (data.veiculo_detalhe.cor_veiculo != null) {
          this.corSelected = {
            label: data.veiculo_detalhe.cor_veiculo.descr,
            value: data.veiculo_detalhe.cor_veiculo.corvei_id,
          };
        }
        if (data.veiculo_detalhe.is_blindado != null) {
          this.isBlindadoSelected = {
            label: data.veiculo_detalhe.is_blindado.descr,
            value: data.veiculo_detalhe.is_blindado.valor,
          };
        }
        if (data.veiculo_detalhe.marca_veiculo != null) {
          this.marcaSelected = {
            label: data.veiculo_detalhe.marca_veiculo.descr,
            value: data.veiculo_detalhe.marca_veiculo.marvei_id,
          };
        }
        if (data.veiculo_detalhe.modelo_veiculo != null) {
          this.modeloSelected = {
            label: data.veiculo_detalhe.modelo_veiculo.descr,
            value: data.veiculo_detalhe.modelo_veiculo.modvei_id,
          };
        }

        if (data.veiculo_detalhe.tp_cambio != null) {
          this.tpCambioSelected = {
            label: data.veiculo_detalhe.tp_cambio.descr,
            value: data.veiculo_detalhe.tp_cambio.valor,
          };
        }

        if (data.veiculo_detalhe.tp_veiculo != null) {
          this.tpVeiculoSelected = {
            label: data.veiculo_detalhe.tp_veiculo.descr,
            value: data.veiculo_detalhe.tp_veiculo.valor,
          };
        }
      }
      if (data.veiculo_motorista.length > 0) {
        data.veiculo_motorista.forEach((item, i) => {
          if (this.shouldPush(item)) {
            this.motoristas.push({
              label:
                item.pessoa_motorista.pessoa_fisica.nome +
                " - " +
                item.pessoa_motorista.pessoa_fisica.cpf,
              value: item.pesmot_id,
              pesmot_id: item.pesmot_id,
              veimot_id: item.veimot_id,
            });
          }
        });
      }

      this.form.veiculo_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.motoristas = this.motoristas;
      this.form.veiculo_detalhe = this.veiculo_detalhe;
      this.form
        .put("/api/" + this.rota + "/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.motoristas = this.motoristas;
      this.form.veiculo_detalhe = this.veiculo_detalhe;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    listaClientesCliente(search) {
      if (search.length >= 3) {
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist/fornecedor")
          .then((response) => {
            this.optionsCliente = [];
            new ReturnApi(response, this, true, false, false);
            this.isLoadingExp = true;

            response.items.forEach((obj) => {
              if (this.shouldPush(obj)) {
              this.optionsCliente.push({
                label:
                  " PJ - " +
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
              }
            });

            response.itemsF.forEach((obj) => {
              if (this.shouldPush(obj)) {
              this.optionsCliente.push({
                label:
                  " PF - " + obj.pessoa.cd + " - " + obj.nome + " - " + obj.cpf,
                value: obj.pessoa_id,
              });
              }
            });

            response.itemsE.forEach((obj) => {
              if (this.shouldPush(obj)) {
              this.optionsCliente.push({
                label:
                  " PE - " +
                  obj.pessoa.cd +
                  " - " +
                  obj.nome +
                  " - " +
                  obj.cuit,
                value: obj.pessoa_id,
              });
              }
            });

            this.isLoadingExp = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          });
      }
    },
    listaProprietario(search) {
      if (search.length >= 3) {
        this.isLoadingProprietario = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsProprietario = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                if (this.shouldPush(obj)) {
                this.optionsProprietario.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
                }
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                if (this.shouldPush(obj)) {
                this.optionsProprietario.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
                }
              });
            }

            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                if (this.shouldPush(obj)) {
                this.optionsProprietario.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
                }
              });
            }

            this.isLoadingProprietario = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    ajustaModelo(data) {
      //vai Adicionar os modelos referentes a marca selecionada
      this.optionsModelo = [];
      this.optionsMarca.forEach((item, i) => {
        if (item.value == data.value) {
          item.modelo_veiculo.forEach((item2, i2) => {
            this.optionsModelo.push({
              label: item2.descr,
              value: item2.modvei_id,
            });
          });
        }
      });
    },
    getLivGeral() {
      this.helpForm
        .post("/api/veiculo/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);

          response.status.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
            }
          });

          response.municipio.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsMunicipio.push({
                label: obj.nome + " - " + obj.uf.cd,
                value: obj.municipio_id,
              });
            }
          });

          response.param_tipo_veiculo.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsParamTipoVeiculo.push({
                label: obj.descr,
                value: obj.partipvei_id,
              });
            }
          });

          response.param_tipo_proprietario.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsParamTipoProprietario.push({
                label: obj.descr,
                value: obj.partipppt_id,
              });
            }
          });

          response.param_tipo_carroceria.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsParamTipoCarroceria.push({
                label: obj.descr,
                value: obj.partipcro_id,
              });
            }
          });

          response.param_tipo_rodado.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsParamTipoRodado.push({
                label: obj.descr,
                value: obj.partiprod_id,
                volume: Math.round(obj.volume, 3) || 0,
                volume_min: Math.round(obj.volume_min, 3) || 0,
                capacidade_peso: Math.round(obj.capacidade_peso, 3) || 0,
                capacidade_peso_min: Math.round(obj.capacidade_peso_min, 3) || 0,
              });
            }
          });

          response.is_blindado.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsIsBlindado.push({ label: obj.descr, value: obj.valor });
            }
          });

          response.tp_cambio.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsTpCambio.push({ label: obj.descr, value: obj.valor });
            }
          });

          response.tp_veiculo.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsTipoVeiculo.push({
                label: obj.descr,
                value: obj.valor,
              });
            }
          });

          response.motorista.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsMotorista.push({
                label: obj.pessoa_fisica.nome + " - " + obj.pessoa_fisica.cpf,
                pesmot_id: obj.pesmot_id,
                value: obj.pesmot_id,
              });
            }
          });

          response.agenciado.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsAgenciado.push({ text: obj.descr, value: obj.valor });
            }
          });

          response.param_tipo_combustivel.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsTpCombustivel.push({
                label: obj.descr,
                value: obj.partpcomb_id,
              });
            }
          });

          response.marca_veiculo.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsMarca.push({
                label: obj.descr,
                value: obj.marvei_id,
                modelo_veiculo: obj.modelo_veiculo,
              });
            }
          });

          response.cor_veiculo.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsCor.push({ label: obj.descr, value: obj.corvei_id });
            }
          });

          response.tp_vinculo.forEach((obj) => {
            if (this.shouldPush(obj)) {
              this.optionsTpVinculo.push({
                text: obj.descr,
                value: obj.valor,
              });
            }
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    limitText(count) {
      return " e ${count} outras pessoas";
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    shouldPush(obj) {
      if ('status' in obj) {
        if (typeof obj.status === 'object' && 'valor' in obj.status) {
          return obj.status.valor == 1;
        }
        return obj.status == 1;
      } else if ('pessoa' in obj) {
        return this.shouldPush(obj.pessoa);
      } else {
        return true;
      }
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>